/**
 * Single source of truth for the company's contact details.
 *
 * These used to be copy-pasted string literals: the Calendly link appeared in
 * 11 places across 10 files and the WhatsApp number in 9, which is how they
 * drifted out of sync. Import from here instead of typing a new literal, so
 * changing one of them stays a one-line edit.
 */

/** Company booking link. Not a personal calendar — keep it that way. */
export const CALENDLY_URL = 'https://calendly.com/contact-omnicraftservices/30min';

/** The only email address the site should ever show. */
export const CONTACT_EMAIL = 'contact@omnicraftservices.com';

/**
 * WhatsApp contact, digits only and in international format (no '+', as wa.me
 * requires).
 *
 * TODO: still the old US number. The Qatar launch needs this replaced with the
 * company's Qatar number; changing it here updates every entry point.
 */
export const WHATSAPP_NUMBER = '12026998621';

/** wa.me link, optionally pre-filled with a message. */
export const whatsappUrl = (message?: string) =>
  message
    ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${WHATSAPP_NUMBER}`;
